import axios from 'axios'

//console.log('axios config: ', process.env.VUE_APP_API_URL)
//console.log('axios2 config: ', process.env)

var instance = axios.create({
    baseURL: process.env.VUE_APP_API_URL + '/api/v1',
})

export default instance
